import { useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Iconify from "../../../components/Iconify";
import React from "react";
import FrmReportDay from "../modals/FrmReportDay";
import FrmReportByDates from "../modals/FrmReportByDates";
const MenuDateReports = ({ setOpenDialog, setBodyDialog, setDatos,setTitle }) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenReportByDy = (e) => {
  
    setBodyDialog(
      <FrmReportDay setTitle={setTitle} setOpenDialog={setOpenDialog} setDatos={setDatos} />
    );
    setOpenDialog(true);
  };

  const handleOpenReportByDates = (e) => {
    //setTitle("Reporte por Fechas");
    setBodyDialog(
      <FrmReportByDates setTitle={setTitle} setOpenDialog={setOpenDialog} setDatos={setDatos} />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem sx={{ color: "text.secondary" }}>
          <ListItemIcon>
          <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Reporte por día de Trabajo"
            primaryTypographyProps={{ variant: "body2" }}
            onClick={() => handleOpenReportByDy()}
          />
        </MenuItem>

        <MenuItem
          component={RouterLink}
          to="#"
          sx={{ color: "text.secondary" }}
        >
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Reporte por Rango de Fechas"
            primaryTypographyProps={{ variant: "body2" }}
            onClick={() => handleOpenReportByDates()}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuDateReports;
